import type { Canvas } from "fabric";
import { useEffect } from "react";

export const useCanvasCopyPasteKeyboardShortcuts = ({
  fabricCanvas,
  copy,
  paste,
}: {
  fabricCanvas?: Canvas;
  copy: () => Promise<void> | void;
  paste: () => Promise<void> | void;
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!fabricCanvas) return;

      const { key, metaKey, ctrlKey } = event;
      const isCtrlOrCmd = ctrlKey || metaKey;

      if (key === "c" && isCtrlOrCmd) void copy();

      if (key === "v" && isCtrlOrCmd) void paste();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [fabricCanvas, copy, paste]);
};
